import { useQueryClient } from '@tanstack/react-query'
import { useMemo } from 'react'
import { POLL_INTERVAL_MS, useCrawlTaskStore } from '~/features/bots/stores/useCrawlerStore'
import { getQueryKey } from '~/services'
import { useDebounceEffect } from '../../../hooks/useDebounceEffect'

export type UseWebSourceCrawlProps = {
  workspaceId: string
  botId: string
  kbId: string
  dsId: string
}

export const useWebSourceCrawl = ({ workspaceId, botId, kbId, dsId }: UseWebSourceCrawlProps) => {
  const crawlTaskStore = useCrawlTaskStore()
  const queryClient = useQueryClient()

  const crawlTask = useMemo(() => {
    return crawlTaskStore.tasks.find((task) => task.dsId === dsId)
  }, [crawlTaskStore.tasks, dsId])

  useDebounceEffect(
    () => {
      if (!crawlTask) return
      crawlTaskStore.cleanInactive()
      if (crawlTask.status !== 'pending') {
        queryClient.invalidateQueries({
          queryKey: getQueryKey('workspaces_/$workspaceId_/bots_/$botId_/knowledgeBases_/$kbId_/sources/$tags/all', {
            workspaceId,
            botId,
            kbId,
            tags: { dsId: dsId },
          }),
        })
      }
    },
    [botId, crawlTask, dsId, kbId, queryClient, workspaceId],
    POLL_INTERVAL_MS
  )

  return crawlTask
}
